module.exports = __webpack_public_path__ + "ab-test-basge.svg?d65805192a2b0b38ce3cc82b57aed679";